import React from "react";
import "../styles/components/game-card.css";
import { gameType } from "../@types/game-type";

interface GameCardProps {
  game: gameType;
  isAllGamesPage: boolean;
  handleClick: (game: gameType) => void;
}

// O componente Game pega os dados dos jogos e os renderiza na tela
function GameCard(props: GameCardProps) {
  const handleGameClick = (e: React.MouseEvent) => {
    console.log("Game clicked:", props.game);
    props.handleClick(props.game);
  };

  return (
    <div className="background-game-card" onClick={handleGameClick}>
      <img
        src={require(`../assets/${props.game.image}`)}
        className="image-game-card"
        alt={props.game.name}
      />
    </div>
  );
}

export default GameCard;
